import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'
import _ from 'lodash/lodash.min.js'

var isDebug = false
var path = '/E106Compliance/'

function get (http, id) {
    return http.get(`${path}Get?complianceId=${id}`)
}

function put (http, dto) {
    return http.put(path, dto)
}

function remove (http, id) {
    return http.post(`${path}Remove?complianceId=${id}`)
}

function search (http, searchDto) {
    loggingService.log(isDebug, 'E106 Compliance Service', 'Search by ' + searchDto.projectId)
    return http.post(`${path}Search`, searchDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
            })
        }
        return response
    })
}

function todo (http, searchDto) {
    loggingService.log(isDebug, 'E106 Compliance Service', 'Todo')
    return http.post(`${path}Todo`, searchDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
                x.latestUpdate = dateService.convertToDate(x.latestUpdate)
            })
        }
        return response
    })
}

function getUrlByObject (dto) {
    return path + dto.e106complianceId
}

function putPlss (http, e106complianceId, plss) {
    loggingService.log(isDebug, 'E106 Compliance Service', 'putPlss - e106complianceId: ' + e106complianceId + ', plss: ' + plss)

    var data = {
        parentId: e106complianceId,
        parentType: 'E106Compliace',
        plssLocation: plss,
        sections: plss.Sections
    }

    return http.put(path + 'PutPlss', data)
}

function listE106CompliancePlssLocationResultDto (http, e106complianceId) {
    loggingService.log(isDebug, 'E106 Compliance Service', 'listE106compliancePlssLocationResultDto')

    return http.get(path + 'ListE106CompliancePlssLocationResultDto?e106complianceId=' + e106complianceId).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })

        return response
    })
}

function deletePlssLocation (http, e106compliancePlssLocationId) {
    loggingService.log(isDebug, 'E106 Compliance Service', 'deletePlssLocation, e106compliancePlssLocationId: ' + e106compliancePlssLocationId)
    return http.delete(path + 'deletePlss?e106compliancePlssLocationId=' + e106compliancePlssLocationId)
}

function publicSubmit (http, submitDto) {
    loggingService.log(isDebug, 'E106 Compliance Service', 'publicSubmit')
    return http.put(path + `PublicSubmit`, submitDto)
}

function uploadFilePublic (http, mediaTypeId, mediaSubtypeId, parentId, fileToUpload, comment, captchaToken) {
    loggingService.log(isDebug, 'E106 Compliance Service', 'uploadFilePublic: ' + ' parentId: ' + parentId)

    var data = new FormData()
    data.append('mediaTypeId', mediaTypeId)
    if (mediaSubtypeId) {
        data.append('mediaSubtypeId', mediaSubtypeId)
    }
    data.append('parentId', parentId)
    data.append('file', fileToUpload)
    data.append('comment', comment)
    data.append('captchaToken', captchaToken)

    return http.post(path + `UploadFilePublic`, data)
}

var e106WorkflowStatusEnum = {
    pendingRequestSubmission: 7000,
    pendingSHPOApproval: 7100,
    pendingSurvey: 7200,
    pendingSHPOReview: 7300,
    denied: 7400,
    completion: 7500
}

export default {
    get: get,
    put: put,
    remove: remove,
    search: search,
    getUrlByObject: getUrlByObject,
    e106WorkflowStatusEnum: e106WorkflowStatusEnum,
    listE106CompliancePlssLocationResultDto: listE106CompliancePlssLocationResultDto,
    putPlss: putPlss,
    deletePlssLocation: deletePlssLocation,
    todo: todo,
    publicSubmit: publicSubmit,
    uploadFilePublic: uploadFilePublic
}



// WEBPACK FOOTER //
// ./src/services/e106ComplianceService.js